/**
 * decodeしたアクセストークン関するユーティリティ関数
 */
import { jwtDecode } from "jwt-decode";

/**
 * アクセストークンをデコードする関数
 * @param token デコードするJWTトークン
 * @returns デコードされたペイロード
 */
function decodeAccessToken(token: string): string | object | null {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
}

export default decodeAccessToken;
